export class GroupGoalSave {
    groupId: number;
    groupGoalIds: number[];
}
